import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import VerificationInput from "react-verification-input";
import { ImageUrl } from "../../config/helpers";
import { useSelector } from "react-redux";
import { Post } from "../../config/api/post";
import { RESET } from "../../config/constants/api";
import swal from "sweetalert";

const ForgotPassword2 = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState(null);
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.userToken);
  const email = location?.state?.email;
  useEffect(() => {
    if (!email) {
      navigate("/forgotPassword");
    }
    // eslint-disable-next-line
  }, []);
  const handleSubmit = () => {
    setLoading(true);
    Post(RESET.verifyCode, { email: email, code: code, type:'ADMIN' }, token)
    .then((response) => {
      if (response?.status) {
          setLoading(false);
          swal("Success", response?.message, "success");
        }
        navigate("/forgotPassword/changePassword", { state: { email: email, code: code } });
      })
      .catch((err) => {
        console.log("Error", err);
        setLoading(false);
        swal("Error", err?.response?.data?.message, "error");
      });
  };
  return (
    <Row
      justify="center"
      style={{
        backgroundImage: `url('${ImageUrl("login.png")}')`, // Setting background color to black with 90% opacity
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      className="h-screen max-sm:pb-8"
      gutter={[16, 0]}
    >
      <Col
        xl={8}
        lg={7}
        md={6}
        sm={0}
        xs={0}
        className="flex justify-center items-end max-md:hidden"
      >
        <img src={ImageUrl("login-2.png")} alt="" />
      </Col>
      <Col
        xl={8}
        lg={10}
        md={12}
        sm={20}
        xs={20}
        className=" items-center flex w-full"
      >
        <div
          className="flex flex-col justify-center items-center bg-white rounded-lg pb-8 px-8 max-lg:px-2 w-full pt-4"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <img src={ImageUrl("logo.png")} width={130} alt="logo" />
          <h3 className="mt-4 font-tavi text-3xl text-black max-md:text-xl">
            Verification Code
          </h3>
          <p className="capitalize font-euclid text-sm text-[#34324B] mb-8 max-md:text-xs text-center">
            An email has been sent to you with a verification code
          </p>
          <VerificationInput
            length={4}
            placeholder="_"
            validChars="0-9"
            classNames={{
              character: "verification-input",
              characterSelected: "verification-input-focused",
            }}
            onChange={(val) => {
              setCode(val);
            }}
          />
          {/* <div className="flex justify-end items-end w-full sm:pr-32 pr-4">
            <Link className="text-[#0B7FC3] text-sm border-b-2 border-[#0B7FC3] mt-4 hover:text-[#0B7FC3] flex justify-end">
              Resend Code
            </Link>
          </div> */}
          <button
            htmlType="submit"
            className="bg-button hover:bg-white hover:border-customGold hover:border-2 font-urban font-bold text-black px-14 h-[50px] hover:text-white text-center text-sm mt-8 rounded-lg max-sm:text-xs"
            onClick={handleSubmit}
            disabled={code?.length !== 4}
          >
            {loading ? "LOADING..." : "CONTINUE"}
            {/* CONTINUE */}
          </button>
          <Link
            to="/login"
            className="font-euclid text-black text-sm border-b-2 border-black font-semibold mt-8 hover:text-black"
          >
            Back to Sign In
          </Link>
        </div>
      </Col>
      <Col
        xl={8}
        lg={7}
        md={6}
        sm={0}
        xs={0}
        className="flex justify-center items-end max-md:hidden"
      >
        <img src={ImageUrl("login-1.png")} alt="" />
      </Col>
    </Row>
  );
};

export default ForgotPassword2;
